<!-- eslint-disable @typescript-eslint/no-magic-numbers -->
<script setup lang="ts">
    import WidgetRangeInput from '@/components/WidgetRangeInput.ce.vue';

    const props = defineProps<{
        modelValue: number
        maxGuestAmount?: number
        minGuestAmount?: number
        guestAmountStep?: number
        event: string
    }>();

    // eslint-disable-next-line func-call-spacing
    const emit = defineEmits<{
        (event: 'update:modelValue', value: number): void
        (event: 'next'): void
    }>();

    const { t } = useI18n();

    const amountModel = ref(props.modelValue ?? 0);

    watch(() => amountModel.value, (nVal: number) => {
        emit('update:modelValue', nVal);
    });
</script>

<template>
    <div class="quote-amount-card">
        <div class="quote-amount-card__container">
            <h3>{{ t('widget.amount.how-many', { event }) }}</h3>
            <WidgetRangeInput
                v-model="amountModel"
                :min="minGuestAmount ?? 0"
                :max="maxGuestAmount ?? 1000"
                :step="guestAmountStep ?? 1"
                secondary
            />
            <button
                :class="{'btn--secondary': !amountModel, 'btn--primary': amountModel}"
                :disabled="!amountModel"
                type="button"
                class="btn quote-amount-card__action"
                @click="emit('next')"
            >
                <span>
                    {{ t('widget.buttons.next') }}
                </span>
            </button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.quote-amount-card {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    block-size: 100%;
    inline-size: 100%;

    h3 {
        font-size: var(--font-h2);
        text-align: center;
        text-transform: lowercase;

        &::first-letter {
            text-transform: uppercase;
        }
    }

    &__container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        block-size: 100%;
        inline-size: 100%;
        min-block-size: 100%;
        padding-inline: var(--spacing-03);
    }

    &__action {
        position: fixed;
        z-index: var(--zindex-stack-twice);
        align-self: center;
        inset-block-end: var(--spacing-05);
        inset-inline-start: 50%;
        min-inline-size: 174px;
        transform: translateX(-50%);

        @include min-width(lg) {
            position: static;
            inset-inline-start: 0;
            margin-block-start: var(--spacing-06);
            transform: none;
        }
    }
}
</style>
